/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/193-menu4': {
    width: 22,
    height: 16,
    viewBox: '0 0 22 16',
    data: '<path pid="0" d="M0 3h14v3H0V3zm0 4h14v3H0V7zm0 4h14v3H0v-3zM15.5 10l3-3 3 3z"/>'
  }
})
